import React from 'react';
import { Helmet } from 'react-helmet-async';
import { FaXTwitter, FaFacebookF, FaLinkedinIn, FaYoutube, FaInstagram } from 'react-icons/fa6';
import DealerList from '../components/DealerList';
import HomeHeader from '../components/Home/HomeHeader';
import HomeSearch from '../components/Home/HomeSearch';
import HomeFooter from '../components/Home/HomeFooter';
import '../styles/SocialFloat.css';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Anyworq – India’s Trusted A-to-Z Service Marketplace</title>
        <meta
          name="description"
          content="Connect with verified service providers across India quickly with Anyworq."
        />
        <link rel="canonical" href="https://www.anyworq.com/" />
        <meta
          name="keywords"
          content="Anyworq, service marketplace India, find professionals online, verified service providers, home services, repair services, construction services, cleaning services, event management, electricians, plumbers, painters, carpenters, beauty services, AC repair, packers and movers, local services India, trusted vendors, A-to-Z services platform"
        />
      </Helmet>

      <div>
        <HomeHeader />
        <HomeSearch />
        <HomeFooter />

        {/* Floating Social Icons */}
        <div className="social-float">
          <a
            href="https://x.com/any_worq"
            className="social-icon twitter"
            target="_blank"
            rel="noopener noreferrer"
            title="X (Twitter)"
          >
            <FaXTwitter />
          </a>

          <a
            href="https://www.facebook.com/profile.php?id=61581679359104"
            className="social-icon facebook"
            target="_blank"
            rel="noopener noreferrer"
            title="Facebook"
          >
            <FaFacebookF />
          </a>

          <a
            href="https://www.linkedin.com/company/109066988/admin/dashboard/"
            className="social-icon linkedin"
            target="_blank"
            rel="noopener noreferrer"
            title="LinkedIn"
          >
            <FaLinkedinIn />
          </a>

          <a
            href="https://www.youtube.com/@anyworq"
            className="social-icon youtube"
            target="_blank"
            rel="noopener noreferrer"
            title="YouTube"
          >
            <FaYoutube />
          </a>

          <a
            href="https://www.instagram.com/anyworq_/"
            className="social-icon instagram"
            target="_blank"
            rel="noopener noreferrer"
            title="Instagram"
          >
            <FaInstagram />
          </a>
        </div>
      </div>
    </>
  );
};

export default Home;
